import { render } from "./QuestionObjectPhoneticConsonant.vue?vue&type=template&id=bc0371ae&scoped=true"
import script from "./QuestionObjectPhoneticConsonant.vue?vue&type=script&lang=js"
export * from "./QuestionObjectPhoneticConsonant.vue?vue&type=script&lang=js"

import "@/css/components/question-object-phonetic-consonant.css?vue&type=style&index=0&id=bc0371ae&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc0371ae"]])

export default __exports__